import { useStats } from '../../../../hooks/EnrollmentsHook/useEnrollmentStats'

const EnrollmenrCardsSection = () => {
  const { stats, statsLoading } = useStats();

  return (
    <div className='flex w-full gap-4'>

      {statsLoading
        ? Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className='flex-1  flex flex-col gap-3 p-6 items-center rounded-[10px] shadow-[0px_0px_6px_0px_#0000000D] animate-pulse'
            >
              <div className='w-10 h-10 bg-gray-200 rounded-full'></div>
              <div className='w-20 h-4 bg-gray-200 rounded'></div>
              <div className='w-12 h-6 bg-gray-200 rounded'></div>
            </div>
          ))
        : stats?.map((stat, index) => (
            <div
              key={index}
              className='flex-1 flex gap-2 border-[#E5E7EB] flex-col pt-3 pb-3 py-6 items-center shadow-[0px_0px_6px_0px_#0000000D] rounded-[10px]'
            >
               <p 
              className='font-medium text-[16px] text-[#8B8B8B]'
               >{stat.label}</p>
              <p 
              className='font-semibold text-[28px] text-[#E74860]'
              >{stat.value}</p>
              <img className='size-14' src={stat.icon} alt="stat-icon" />
             
            </div>
          ))}

    </div>
  )
}

export default EnrollmenrCardsSection